import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, withStyles } from "@material-ui/core";

import LoadingIndicatorStyles from "./LoadingIndicator.styles";

export const LoadingIndicator = ({
  width,
  classes,
  className,
  isLoading,
  text,
  isFullScreen,
  ...rest
}) =>
  isLoading &&
  <div className={isFullScreen ? classes.fullScreen : ""}>
    <CircularProgress
      className={classes.loader}
      color="inherit"
      size={width}
      thickness={5}
      {...rest}
    />
    <span className={isFullScreen ? classes.text : ""}>
      {text || ""}
    </span>
  </div>;

LoadingIndicator.propTypes = {
  classes: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  width: PropTypes.number
};
LoadingIndicator.defaultProps = {
  width: 20,
  isFullScreen: false
};

export default withStyles(LoadingIndicatorStyles)(LoadingIndicator);
